module.exports = __webpack_public_path__ + "img/base_model1.64abf606.png";